
export default function Products() {
  const products = [
    {
      id: 1,
      name: 'VPN Security',
      description: 'Protect your online privacy with military-grade encryption',
      gradient: 'from-purple-400/20 to-purple-600/20',
      bgColor: 'bg-blue-50/50',
      image: 'https://public.readdy.ai/ai/img_res/f3e7c10e68ad9a33db408da9f18a8060.jpg',
      features: ['Unlimited bandwidth', 'Global server network', 'No-logs policy']
    },
    {
      id: 2,
      name: 'Device Cleaner',
      description: 'Optimize your device performance and free up storage space',
      gradient: 'from-green-400/20 to-green-600/20',
      bgColor: 'bg-gray-50',
      image: 'https://readdy.ai/api/search-image?query=clean%20minimalist%20mobile%20device%20optimization%20icon%20with%20broom%20or%20sparkle%20elements%20on%20soft%20green%20gradient%20background%20modern%20app%20icon%20design%20representing%20storage%20cleaning%20and%20performance%20boost&width=400&height=400&seq=prod002&orientation=squarish',
      features: ['Smart cleaning', 'Battery optimization', 'Memory management']
    },
    {
      id: 3,
      name: 'Privacy Guard',
      description: 'Advanced protection for your personal data and browsing',
      gradient: 'from-blue-400/20 to-blue-600/20',
      bgColor: 'bg-gray-50',
      image: 'https://readdy.ai/api/search-image?query=elegant%20privacy%20protection%20shield%20icon%20with%20eye%20or%20fingerprint%20symbol%20on%20soft%20blue%20gradient%20background%20modern%20minimalist%20app%20icon%20style%20representing%20data%20security%20and%20personal%20information%20protection&width=400&height=400&seq=prod003&orientation=squarish',
      features: ['Ad blocking', 'Tracker prevention', 'Secure browsing']
    }
  ];

  return (
    <div className="bg-white py-32 px-8 lg:px-16" data-product-shop>
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-20 gap-8">
          <h2 className="text-6xl lg:text-7xl font-thin text-gray-900">
            Our Products
          </h2>
          <p className="text-base text-gray-600 max-w-md lg:text-right">
            Discover our suite of premium iOS applications designed to enhance your mobile experience with security and performance at the forefront.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {products.map((product) => (
            <div
              key={product.id}
              className={`${product.bgColor} rounded-3xl p-8 transition-transform hover:scale-105 cursor-pointer`}
            >
              <div className={`bg-gradient-to-br ${product.gradient} rounded-3xl p-12 mb-8 flex items-center justify-center`}>
                <div className="w-full h-64 flex items-center justify-center">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-48 h-48 object-contain"
                  />
                </div>
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 text-center mb-4">
                {product.name}
              </h3>
              
              <p className="text-gray-600 text-center mb-6 min-h-12">
                {product.description}
              </p>
              
              <div className="space-y-3 mb-8">
                {product.features.map((feature, index) => (
                  <div key={index} className="flex items-center gap-2 text-sm text-gray-700">
                    <i className="ri-check-line text-green-600 w-5 h-5 flex items-center justify-center"></i>
                    <span>{feature}</span>
                  </div>
                ))}
              </div>
              
              <div className="flex justify-center">
                <button className="border-2 border-gray-900 text-gray-900 rounded-full px-12 py-3 font-medium hover:bg-gray-900 hover:text-white transition-colors whitespace-nowrap cursor-pointer w-4/5">
                  Learn More
                </button>
              </div>
              
              <p className="text-xs text-gray-400 text-center mt-6">
                Available on iOS devices
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
